import React, { useEffect, useState } from 'react'
import SuperSearchMultipleClient from '../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import isNull from '../../../../utils/NullChecking';

const ModalFilterItem = ({ type, ItemLists, setSelectedIDs, showFilterOptions, defaultSelectedItems: selectedItems, setDefaultSelectedItem: setSelectedItems, selectType, ...props }) => {

  let defaultsearchValue = selectedItems?.[0]?.display || '';
  const [searchValue, setSearchValue] = useState(defaultsearchValue);
  const [is, setIs] = useState(true);

  const handleChange = (e) => {
    setIs(false)
    let { name, value } = e.target
    setSearchValue(value)
  }
  const handleSelectedDataa = (selectedData, name, type) => {
    setIs(true)
    if (type === 'client' && !isNull(selectedData)) {
      setSelectedItems([selectedData]);
      setSelectedIDs(selectedData.value);
      setSearchValue(selectedData?.display);
    } else {
      setSelectedItems([]);
      setSelectedIDs('');
      setSearchValue('');
    }
    return selectedData
  }
  // console.log("selectedItemsClear",type, selectedItems)
  return (<>        
    <div className="input ">
      {props?.label ? <p className="text pb-3px">{props?.label}</p> : <></>}
      {selectType === 'multiple' ? 
      <SuperSearchMultipleClient
        id={type}
        name={type}
        selectedOptionsDisplay={props?.label}
        initialSelectedValues={selectedItems}
        options={ItemLists?.filter(item => !['-1', -1].includes(item.value))}
        searchParam={{ [type] : selectedItems.map(x => x.value).join(', ') }}
        setSearchParam={(value) => {
            if (value === null || value === undefined || value === '') {
                // setSelectedItems([])
            } else {
                let selectedData = value?.[type].split(', ').map(value => ItemLists.find(form => form.value == value)).filter(Boolean);
                setSelectedItems(selectedData);
                setSelectedIDs(selectedData.map(item => item.value).join(','));
            }
          } 
        }
        ScrollOutside={true}
        sup_btn="sup_btn-Inp"
        sup_inp="superSearchVisitInp"
      /> :
        <SuperSearchList
          type="client"
          id={type}
          name={type}
          searchValue={searchValue}
          data={ItemLists}
          onChange={handleChange}
          getSelectedData={handleSelectedDataa}
          is={is}
          icon={'Simple'}
          ScrollOutside={true}
          sup_btn='sup_btn'
          sup_inp='superSearchVisitInp'
          // className="form-control rounded"
        />
      }
    </div>
  </>
  );
};
export default ModalFilterItem